import React, { useEffect } from "react";
import "./ManagementTeam.css";

const teamMembers = [
  {
    name: "Moritz Abazie",
    role: "Chief Executive Officer",
    image: require("./management photo/Moritz Abazie ceo.jpg"),
    blurb:
      "Leads the company strategy, governance and growth agenda with a focus on sustainable performance and long-term value creation.",
  },
  {
    name: "Chukwuemeka Obiagwu",
    role: "Chairman, Independent Director",
    image: require("./management photo/Chukwuemeka Obiagwu CHAIRMAN INDEPENDENT DIRECTOR.jpg"),
    blurb:
      "Provides independent oversight, governance direction and strategic guidance across the company and its stakeholders.",
  },
  {
    name: "Benjamin Agwuncha",
    role: "Executive Director, Finance & Admin",
    image: require("./management photo/Benjamin Agwuncha ED Finance  Admin.jpg"),
    blurb:
      "Oversees financial stewardship, administration and the systems that support accountable business performance.",
  },
  {
    name: "Kelechi Achinihu",
    role: "Executive Director, Logistics",
    image: require("./management photo/Kelechi Achinihu ED - Logistics.jpg"),
    blurb:
      "Directs logistics capability and resource coordination to keep projects and field operations moving efficiently.",
  },
  {
    name: "Prospect Maduforo",
    role: "Project Director, Subsea Services",
    image: require("./management photo/Prospect Maduforo Project Director, Subsea Services.png"),
    blurb:
      "Leads subsea project delivery, technical coordination and field execution across underwater service assignments.",
  },
  {
    name: "Francis Oloworaran",
    role: "Executive Director, Projects",
    image: "/images/francis.webp",
    blurb:
      "Coordinates project planning, technical execution and stakeholder alignment for disciplined project delivery.",
  },
  {
    name: "Constance Obiodu",
    role: "Deputy General Manager, Finance & Accounts",
    image: require("./management photo/Constance Obiodu DGM, Finance and Account.png"),
    blurb:
      "Supports financial planning, reporting and account management across the company's operational activities.",
  },
  {
    name: "Jessica Essien",
    role: "Team Lead, GEMO",
    image: require("./management photo/Jessica Essien Team Lead, GEMO.png"),
    blurb:
      "Coordinates GEMO team activities and supports structured delivery across operational and project priorities.",
  },
  {
    name: "Jide Bisiriyu",
    role: "Project Manager",
    image: require("./management photo/Jide Bisiriyu Project Manager.png"),
    blurb:
      "Manages project planning, coordination and execution to keep assignments aligned with client requirements.",
  },
  {
    name: "Nneka Anih",
    role: "HR Superintendent",
    image: require("./management photo/Nneka Anih HR Superintendent.jpg"),
    blurb:
      "Supports people operations, workforce coordination and the development of a strong team culture.",
  },
  {
    name: "Nnenna Ezeakabekwe",
    role: "Senior Accounts Manager",
    image: require("./management photo/Nnenna Ezeakabekwe Senior Accounts Manager.png"),
    blurb:
      "Manages account processes and financial coordination that support reliable reporting and business control.",
  },
  {
    name: "Dr. Onyema Chidubem Abazie",
    role: "Senior Leadership",
    image: "/images/madam pics.webp",
    blurb:
      "Contributes leadership experience and professional expertise to the company's people and operational priorities.",
  },
  {
    name: "Sylvanus Alao",
    role: "HSE Manager",
    image: require("./management photo/Sylvanus Alao HSE Manager.jpg"),
    blurb:
      "Drives health, safety and environmental standards across projects, teams and operational environments.",
  },
];

function ManagementTeam() {
  useEffect(() => {
    if (window.location.hash === "#ceo") {
      document.getElementById("ceo")?.scrollIntoView();
    }
  }, []);

  return (
    <main className="management-page">
      <section className="management-hero">
        <img
          className="management-hero-image"
          src="/images/meeting.webp"
          alt="Strides management team meeting"
        />

        <div className="management-hero-overlay"></div>

        <div className="management-container management-hero-content">
          <span className="management-label">Management Team</span>

          <h1>
            Leadership that keeps
            <br />
            <span>every mission moving.</span>
          </h1>

          <p>
            Our leadership team brings strategic direction, field expertise and
            disciplined execution to every project and partnership we undertake.
          </p>
        </div>
      </section>

      <section className="management-intro section-light">
        <div className="management-container">
          <div className="section-heading">
            <h2>
              Experienced leaders
              <br />
              <span>driving progress.</span>
            </h2>
          </div>

          <div className="management-grid">
            {teamMembers.map((member) => (
              <article
                className="team-card"
                id={member.role === "Chief Executive Officer" ? "ceo" : undefined}
                key={member.name}
              >
                <div className="team-photo">
                  <img src={member.image} alt={member.name} />
                </div>

                <div className="team-body">
                  <h3>{member.name}</h3>
                  <h4>{member.role}</h4>
                  <p>{member.blurb}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="management-principles">
        <div className="management-container">
          <div className="section-heading centered">
            <span className="management-label">How we work</span>
            <h2>
              Built on <span>clarity, safety and accountability.</span>
            </h2>
          </div>

          <div className="principles-grid">
            <div className="management-principle-card">
              <span className="management-principle-number">01</span>
              <h3>Strategic Leadership</h3>
              <p>
                We align business priorities with operational realities to create
                sustainable growth and stronger client outcomes.
              </p>
            </div>

            <div className="management-principle-card dark-card">
              <span className="management-principle-number">02</span>
              <h3>Operational Excellence</h3>
              <p>
                Every project is governed by disciplined execution, measurable
                performance and continuous improvement.
              </p>
            </div>

            <div className="management-principle-card">
              <span className="management-principle-number">03</span>
              <h3>Safety First</h3>
              <p>
                We embed strong HSE systems and standards to protect our teams,
                communities and the environments we operate in.
              </p>
            </div>

            <div className="management-principle-card dark-card">
              <span className="management-principle-number">04</span>
              <h3>Partnership Focus</h3>
              <p>
                Trusted relationships with clients, regulators and stakeholders are
                central to how we deliver value and build confidence.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ManagementTeam;
